import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  static targets = ['select']
  static values = {
    tab: String
  }

  tabValue!: string

  submit (event: Event): void {
    const form = this.element as HTMLFormElement
    const url = new URL(form.action, window.location.origin)

    const formData = new FormData(form)
    for (const [key, value] of formData.entries()) {
      url.searchParams.append(key, String(value))
    }

    const tab = typeof this.tabValue === 'string' && this.tabValue.trim() !== ''
      ? this.tabValue
      : 'assessment'
    url.hash = tab

    Turbo.visit(url.toString())
  }
}
